// Note: This file is in git ignore.
export const firebaseConfig = {
	apiKey: "AIzaSyD_x7w-0mC1CJ8F-8cI0Lv3qWvtjRSd98M",
	authDomain: "multi-user-login.firebaseapp.com",
	databaseURL: "https://multi-user-login.firebaseio.com",
	projectId: "multi-user-login",
	storageBucket: "multi-user-login.appspot.com",
	messagingSenderId: "720608961489",
	appId: "1:720608961489:web:0a85ab8a2725c744ec76f0",
	measurementId: "G-CRWPWCK3CH"
};
